import { useCallback } from 'react'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'


export interface OrderWarningIncompatiblesBillingBuyTypeProps {
    BillingTypeBuyOptions: TwinDictionary
}

export const OrderWarningIncompatiblesBillingBuyType: React.FC<OrderWarningIncompatiblesBillingBuyTypeProps> = ({ BillingTypeBuyOptions }) => {
    const { handleIncompatible } = useOrderWarningIncompatiblesBillingBuyTypeLogic()
    const warningIncompatible = handleIncompatible(BillingTypeBuyOptions)
    return (
        <div className='flex flex-col justify-center h-full text-center '>
            {warningIncompatible}
        </div>
    )
}


const useOrderWarningIncompatiblesBillingBuyTypeLogic = () => {
    const { t } = useTwinTranslation()
    const parseBuyAndDeliveryNotes = useCallback((incompatibles: string[]) => {
        const result: string[] = []
        for (const order of incompatibles) {
            const text = (result.length === 0 ? t('the', 'El') : t('theS', 'el')) + ' ' + order
            result.push(text)
        }
        const parsed = result.join(' y ')
        if (parsed.length > 1) {
            return t('warning', '¡Advertencia!') + ' ' + parsed + ' ' + t('notCompatiblesBTO', 'no son compatibles por el tipo de facturación')
        }
    }, [t])

    const handleIncompatible = useCallback((BillingTypeBuyOptions: TwinDictionary) => {
        delete BillingTypeBuyOptions[BillingTypeBuyOptions.win]
        delete BillingTypeBuyOptions.win
        const orders: string[] = []
        for (const key in BillingTypeBuyOptions) {
            const elements = BillingTypeBuyOptions[key]
            for (const subelement of elements) {
                orders.push(subelement)
            }
        }
        return parseBuyAndDeliveryNotes(orders)
    }, [parseBuyAndDeliveryNotes])


    return { handleIncompatible }
}
export interface OrderWarningIncompatiblesBillingSellTypeProps {
    BillingTypeSellOptions: TwinDictionary
}

export const OrderWarningIncompatiblesBillingSellType: React.FC<OrderWarningIncompatiblesBillingSellTypeProps> = ({ BillingTypeSellOptions }) => {
    const { handleIncompatible } = useOrderWarningIncompatiblesBillingSellTypeLogic()
    const warningIncompatible = handleIncompatible(BillingTypeSellOptions)
    return (
        <div className='flex flex-col justify-center h-full text-center '>
            {warningIncompatible}
        </div>
    )
}


const useOrderWarningIncompatiblesBillingSellTypeLogic = () => {
    const { t } = useTwinTranslation()
    const parseSellAndDeliveryNotes = useCallback((incompatibles: string[]) => {
        const result: string[] = []
        for (const order of incompatibles) {
            const text = (result.length === 0 ? t('the', 'El') : t('theS', 'el')) + ' ' + order
            result.push(text)
        }
        const parsed = result.join(' y ')
        if (parsed.length > 1) {
            return t('warning', '¡Advertencia!') + ' ' + parsed + ' ' + t('notCompatiblesBTO', 'no son compatibles por el tipo de facturación')
        }
    }, [t])

    const handleIncompatible = useCallback((BillingTypeSellOptions: TwinDictionary) => {
        delete BillingTypeSellOptions[BillingTypeSellOptions.win]
        delete BillingTypeSellOptions.win
        const orders: string[] = []
        for (const key in BillingTypeSellOptions) {
            const elements = BillingTypeSellOptions[key]
            for (const subelement of elements) {
                orders.push(subelement)
            }
        }
        return parseSellAndDeliveryNotes(orders)
    }, [parseSellAndDeliveryNotes])


    return { handleIncompatible }
}